import React from "react";
import { Cpu, HardDrive, KeyRound, MemoryStick, Server } from "lucide-react";
import KindTag from "./KindTag";

const ICONS = {
  bdf: HardDrive,
  cxl: MemoryStick,
  cwp: Server,
  token: KeyRound,
  firmware: Cpu,
};

const ProductGrid = (props) => {
  const { dataSource } = props;

  return (
    <section className="nfw-section nfw-section-alt">
      <span className="nfw-anchor" id={dataSource.id} />
      <div className="nfw-wrap">
        <div className="nfw-section-head">
          <div>
            {dataSource.kicker && (
              <p className="nfw-kicker">{dataSource.kicker}</p>
            )}
            <h2 className="nfw-h2">{dataSource.title}</h2>
          </div>
          {dataSource.subtitle && (
            <p className="nfw-lead">{dataSource.subtitle}</p>
          )}
        </div>
        <div className="nfw-cards">
          {dataSource.items.map((item) => {
            const Icon = ICONS[item.name] || Cpu;
            return (
              <a className="nfw-card nfw-glass" href={item.href} key={item.name}>
                <div className="nfw-card-head">
                  <div className="nfw-card-icon">
                    <Icon size={22} />
                  </div>
                  <KindTag kind={item.kind} label={item.kindLabel} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                {item.tags && (
                  <div className="nfw-tags">
                    {item.tags.map((tag) => (
                      <span className="nfw-tag" key={tag}>
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
